export default __webpack_public_path__ + "static/media/cancel.6728eaf0.svg";